var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnion = function SvgUnion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2 12.3H6.8v4.8h26.4v-4.8ZM6.8 28.7V17.9h26.4v10.8H6.8ZM6 11.5v18h28v-18H6Zm4.5 11.9h8v-.8h-8v.8Z",
    fill: "currentColor"
  })));
};
export default SvgUnion;